import { render, staticRenderFns } from "./recoverpwd-2.vue?vue&type=template&id=58ffd564&scoped=true&"
import script from "./recoverpwd-2.vue?vue&type=script&lang=js&"
export * from "./recoverpwd-2.vue?vue&type=script&lang=js&"
import style0 from "./recoverpwd-2.vue?vue&type=style&index=0&id=58ffd564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ffd564",
  null
  
)

export default component.exports